export default __webpack_public_path__ + "static/media/coming-soon-envelope.b9cf7732.png";